/*
 * @Description: 注册成功页面
 * @Author: 陈威达
 * @Date: 2022-04-20 15:36:15
 * @LastEditors: 陈威达
 * @LastEditTime: 2022-04-20 15:59:13
 */

import { Button } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import styles from './success.scss'
const RegisterSuccess = () => {
  const onRedirect = () => {
    window.location.replace('https://cloud.gerlun.com')
  }
  return <div className={styles['container']}>
    <div className={styles['icon-box']}>
      <div>
        <CheckCircleOutlined className={styles['icon']}/>
      </div>
      <div>注册成功</div>
    </div>

    <p>请访问概而论官网（www.gerlun.com）</p>
    <p>激活或购买产品吧！</p>
    <div className={styles['btns']}>
      <Button type='primary' block onClick={onRedirect}>
      返回
      </Button>
    </div>
  </div>
}

export default RegisterSuccess
